import React, {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {BackButton, Button, Container, Input, Text} from '../../../components/@FreeModel';
import Header from '../../../components/general/Header/Header';
import {useDispatch, useSelector} from "react-redux";
import {selectApplication} from "../../../db/selectors";
import {gql, queryApplication, updateApplication} from "../../../db/model";

const TaxInfoIndividual = (): React.ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const {applicationID} = useParams()
  const application = useSelector(selectApplication)

  const [businessLegalName, setBusinessLegalName] = useState(application.businessLegalName ?? '');

  const isValid = businessLegalName !== ''

  useEffect(() => {
    // @ts-ignore
    dispatch(gql({
      query: queryApplication,
      variables: {id: applicationID},
      onSuccess: (data) => {
        setBusinessLegalName(data.application?.businessLegalName ?? '')
      }
    }))
  }, [dispatch, applicationID, setBusinessLegalName]);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // @ts-ignore
    dispatch(gql({
      query: updateApplication,
      variables: {
        id: applicationID,
        form: {
          businessLegalName: businessLegalName,
          federalClassification: {
            type: "Individual",
          },
        }
      },
      onSuccess: (_) => navigate(`/contractors/${applicationID}/tax-info/individual/address`)
    }))
  };

  return (
    <Container>
      <Header title="Add Tax Info"/>
      <BackButton to={`/contractors/${applicationID}/tax-info`}/>

      <br/>
      <form onSubmit={handleSubmit}>
        <Text weight="semibold">What is your legal name (as shown on your tax return)?</Text>

        <br/>

        <Input
          label="Legal Name"
          id="legal-name"
          type="text"
          value={businessLegalName}
          onChange={e => setBusinessLegalName(e.target.value)}
          required
        />

        <br/>
        <br/>
        <br/>

        <Button disabled={!isValid}>Continue</Button>
      </form>
    </Container>
  );
};

export default TaxInfoIndividual;
